import { useState } from 'react'
import Modal from 'features/modal/Modal'
import LocationHours from './LocationHours/LocationHours'
import MenuHours from './MenuHours/MenuHours'
import HolidayHours from './HolidayHours/HolidayHours'
import { HoursAvailabilityTitle, HoursAvailabilityWrapper, SectionEditIcon, SectionSeparator } from './styles'

type Props = {
  partnerId: string
  isOpen: boolean
  onClose: () => void
}

const HoursModal = ({
  partnerId,
  isOpen,
  onClose,
}: Props) => {
  const [activeSection, setActiveSection] = useState<'location' | 'menu' | 'holiday' | null>(null)

  if (!isOpen) return null

  return (
    <Modal width='600px' height='auto' isOpen={isOpen} onClose={onClose} showCloseIcon={true} closeOnOutsideClick={false}>
      <HoursAvailabilityWrapper>
        <HoursAvailabilityTitle>Hours</HoursAvailabilityTitle>
        <SectionSeparator />
        <LocationHours
          partnerId={partnerId}
          isEditing={activeSection === 'location'}
          setIsEditing={() => setActiveSection(activeSection === 'location' ? null : 'location')}
        />
        <SectionSeparator />
        <SectionEditIcon onClick={() => setActiveSection(activeSection === 'location' ? null : 'location')} />
        
        <SectionSeparator />
        <HolidayHours
          partnerId={partnerId}
          isEditing={activeSection === 'holiday'}
          setIsEditing={() => setActiveSection(activeSection === 'holiday' ? null : 'holiday')}
        />
        <SectionSeparator />
        <SectionEditIcon onClick={() => setActiveSection(activeSection === 'holiday' ? null : 'holiday')} />

        <SectionSeparator />
        <MenuHours
          partnerId={partnerId}
          isEditing={activeSection === 'menu'}
          setIsEditing={() => setActiveSection(activeSection === 'menu' ? null : 'menu')}
        />
        <SectionSeparator />
        <SectionEditIcon onClick={() => setActiveSection(activeSection === 'menu' ? null : 'menu')} />  
      </HoursAvailabilityWrapper>
    </Modal>
  )
}

export default HoursModal
